module.exports = __webpack_public_path__ + "static/media/orchids.518c0479.png";